<template>
    <v-container class="pa-0">
      <v-form ref="form">
          <v-card class="mt-24px card">
            <v-row class="mb-4">
              <v-col>
                <h2 class="left mr-3">Dodatočné informácie <span v-if="spoludlznik">- spolužiadateľ</span></h2>
              </v-col>
            </v-row>
            <template v-for="(row, index) in rows">
              <template v-if="index == 3">
                <v-divider :key="index" class="mb-6"></v-divider>
              </template>
  
              <v-row v-if="isScoringLoaded" :key="'row' + index">
                <template v-for="column in row">
                  <v-col cols="4"  :key="column.categoryId" style="align-self: end" v-if="column.categoryId != 0">
                    <span class="sumar-dodat-info-label">{{ column.label }}</span>
                    <br />
                    <span class="sumar-dodat-info-label-info">
                      {{ column.labelInfo }}
                    </span>
                    <template v-if="column.type == 'auto'">
                      <v-autocomplete
                        :items="column.items"
                        placeholder="Zvoľte typ"
                        class="dynamic-input-control dynamic-input-sumar dense"
                        outlined
                        v-model="column.value"
                        item-text="display_member"
                        item-value="value_member"
                        :rules="column.required ? [rules.required] : []"
                        @change="(val) => {
                          $emit('changeDirty');
                          if(column.categoryId == 9800){
                            $emit('checkRequireSpoludlznik',column.value == 2)
                          }
                        }"
                        stopMouseDown
                      >
                      <template slot="append-outer" v-if="column.valueInfo">
                        <v-tooltip top max-width="350">
                          <template v-slot:activator="{ on }">
                            <v-icon
                              class=" btn-help text-body-2"
                              style="cursor: pointer"
                              v-on="on"
                            >
                              mdi-help-circle
                            </v-icon>
                          </template>
                          <span>{{ column.valueInfo }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                    </template>
                    <template v-else-if="column.type == 'date'">
                      <DatePicker
                        class="dynamic-input-sumar"
                        hide-error-icon
                        placeholder="DD/MM/YYYY"
                        v-model="column.value"
                        :appendIcon="column.valueInfo ? 'mdi-help-circle' : ''"
                        :tooltipAppendIcon="column.valueInfo ? column.valueInfo : ''"
                        :rules="[column.id != 7 ? rules.required : getZamestnanyOdReuired()]"
                        @change="$emit('changeDirty')"
                        stopMouseDown
                      />
                    </template>
                    <template v-else>
                      <template v-if="column.isAmount">
                        <numeric-text-box
                          class="dynamic-input-control dynamic-input-sumar"
                          v-model="column.value"
                          :key="column.categoryId"
                          suffix="€"
                          :rules="[rules.required]"
                          @change="$emit('changeDirty')"
                          stopMouseDown
                        >
                        <template slot="append" v-if="column.valueInfo">
                            <v-tooltip top max-width="350">
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  class="btn-help text-body-2"
                                  style="cursor: pointer"
                                  v-on="on"
                                >
                                  mdi-help-circle
                                </v-icon>
                              </template>
                              <span>{{ column.valueInfo }}</span>
                            </v-tooltip>
                        </template>
                        </numeric-text-box>
                      </template>
                      <template v-else>
                        <v-text-field
                          v-model="column.value"
                          class="dynamic-input-control dynamic-input-sumar"
                          outlined
                          :key="column.categoryId"
                          :rules="[rules.required]"
                          @change="$emit('changeDirty')"
                          @mousedown.stop
                        >
                          <template slot="append" v-if="column.valueInfo">
                            <v-tooltip top max-width="350">
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  class="btn-help ml-2 mt-1 text-body-2"
                                  style="cursor: pointer"
                                  v-on="on"
                                >
                                  mdi-help-circle
                                </v-icon>
                              </template>
                              <span>{{ column.valueInfo }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>                  
                      </template>
                    </template>
                  </v-col>
                </template>
              </v-row>
            </template>
            <v-divider></v-divider>
            <v-row class="mt-8">
              <v-col cols="4">
                <v-checkbox
                  style="white-space: nowrap; margin-top: 0px"
                  v-bind:class="{
                    dynamic_check_box: true,
                  }"
                  label="Chcem pridať ďalší príjem"
                  v-model="showDalsiPrijem"
                  @change="$emit('changeDirty')"
                />
              </v-col>
            </v-row>
            <v-row v-show="showDalsiPrijem">
              <v-col cols="4" style="align-self: end">
                <span class="sumar-dodat-info-label">{{ dalsiPrijem.inyTypPrijmu.label }}</span>
                <br />
                <span class="sumar-dodat-info-label-info">
                  {{ dalsiPrijem.inyTypPrijmu.labelInfo }}
                </span>
                <v-autocomplete
                  :items="dalsiPrijem.inyTypPrijmu.items"
                  placeholder="Zvoľte typ"
                  class="dynamic-input-control dynamic-input-sumar dense"
                  outlined
                  v-model="dalsiPrijem.inyTypPrijmu.value"
                  :rules="showDalsiPrijem ? [rules.required] : []"
                  item-text="display_member"
                  item-value="value_member"
                  @change="$emit('changeDirty')"
                  stopMouseDown
                >
                <template slot="append-outer" v-if="dalsiPrijem.inyTypPrijmu.valueInfo">
                  <v-tooltip top max-width="350">
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class=" btn-help text-body-2"
                        style="cursor: pointer"
                        v-on="on"
                      >
                        mdi-help-circle
                      </v-icon>
                    </template>
                    <span>{{ dalsiPrijem.inyTypPrijmu.valueInfo }}</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
              </v-col>
              <v-col cols="4" style="align-self: end">
                <span class="sumar-dodat-info-label">{{ dalsiPrijem.inyCistyPrijem.label }}</span>
                <br />
                <span class="sumar-dodat-info-label-info">
                  {{ dalsiPrijem.inyCistyPrijem.labelInfo }}
                </span>            
                <numeric-text-box
                  class="dynamic-input-control dynamic-input-sumar"
                  v-model="dalsiPrijem.inyCistyPrijem.value"
                  :rules="showDalsiPrijem ? [rules.required] : []"
                  suffix="€"
                  @change="$emit('changeDirty')"
                  stopMouseDown
                >
                <template slot="append" v-if="dalsiPrijem.inyCistyPrijem.valueInfo">
                  <v-tooltip top max-width="350">
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class="btn-help text-body-2"
                        style="cursor: pointer"
                        v-on="on"
                      >
                        mdi-help-circle
                      </v-icon>
                    </template>
                    <span>{{ dalsiPrijem.inyCistyPrijem.valueInfo }}</span>
                  </v-tooltip>
              </template>
              </numeric-text-box>
              </v-col>
            </v-row>
          </v-card>
      </v-form>
    </v-container>
  </template>
  <script>
  import CheckBox from '../basic/CheckBox.vue';
  import DatePicker from '../basic/DatePicker.vue';
  import NumericTextBox from '../basic/NumericTextBox.vue';
  import protectedAxios from '../../auth/axios';
  import { mapGetters, mapMutations, mapState } from 'vuex';
  import { eventBus } from '../../main';
  // import { pripadLinkMixin } from '../../mixins/pripadLinkMixin';
  
  export default {
    props: {
        spoludlznik: Boolean,
        cislo_plz: String,
        value: Array
    },
    components: {
      CheckBox,
      DatePicker,
      NumericTextBox
    },
    data: () => ({
      // dialog: 0,
      jeSpoludlznik: false,
      rules: {
        email: value => {
          if (!value) return true;
          if (
            //podla RFC 5322
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              value
            )
          )
            return true;
          else return 'Nesprávny formát e-mailovej adresy';
        },
        rodCislo: value => {
          if (!value) return true;
          if (value.length === 9 && /^[0-9]{6}[0-9]{3}$/.exec(value) && value.substring(0, 2) < 54)
            return true;
          if (value.length === 10 && /^[0-9]{6}[0-9]{4}$/.exec(value) && value % 11 === 0)
            return true;
          else return 'Zadané rodné číslo je nesprávne!';
        },
        required: value => {
          return !!value || value === 0 || 'Povinné pole';
        },
      },
      isScoringLoaded: false,
      dodatocneInfo: {
        stav: null,
        plnolete: 0,
        nezaopatrene: 0,
        doSedemnast: 0,
        doDvatsatSest: 0,
        ico: null,
        od: null,
        cistyPrijem: 0,
        dochodok: 0,
        stanovene: 0,
        zavazky: 0,
        splatky: 0,
        dalsiPrijem: false,
        inyTyp: ''
      },
      showDalsiPrijem: false,
      dalsiPrijem:{
        inyCistyPrijem:{
          id: 13,
          label: '',
          labelInfo: '',
          value: 0,
          categoryId: 0,
          valueInfo: '',
          type: 'text',
        },
        inyTypPrijmu: {
          id: 14,
          label: '',
          labelInfo: '',
          items: [],
          value: 0,
          categoryId: 0,
          valueInfo: 'Iný príjem je potrebné zdokladovať. V prípade, že máte viac iných príjmov, prosím kontaktujte Tatra-Leasing, s.r.o +421 2 5919 5919.',
          type: 'auto',
        },
      },
      categories:{
        // categoryId dlznika
        9800: 1,
        37: 2,
        64: 3,
        34: 4,
        33: 5,
        9810: 6,
        9820: 7,
        9830: 8,
        9850: 9,
        36: 10,
        49: 11,
        35: 12,

        78: 14,
        66: 13,
        // categoryId spoludlznika
        9900: 1,
        81: 2,
        65: 3,
        77: 4,
        76: 5,
        9910: 6,
        9920: 7,
        9930: 8,
        9950: 9,
        80: 10,
        72: 11,
        70: 12,

        79: 14,
        82: 13
      },
      rows: [
        [
          {
            id: 1,
            label: 'Rodinný stav',
            required: false,
            categoryId: 0,
            labelInfo: '',
            value: null,
            items: [],
            valueInfo: '',
            type: 'auto',
          },
        ],
        [
          {
            id: 2,
            label: 'Počet plnoletých osôb v domácnosti',
            required: true,
            categoryId: 0,
            labelInfo: '(okrem nezaopatrených detí)',
            value: null,
            items: [],
            valueInfo: 'Počet osôb, ktorých príjem bude posudzovaný v schvaľovacom procese.',
            type: 'auto',
          },
          {
            id: 3,
            label: 'Počet nezaopatrených detí',
            categoryId: 0,
            labelInfo: '',
            value: 0,
            items: [],
            valueInfo: 'Za nezaopatrené dieťa sa považuje každé dieťa od narodenia do skončenia povinnej školskej dochádzky, maximálne však do dovŕšenia 18. roku života.',
            type: 'text',
            isAmount: false,
          },
        ],
        [
          {
            id: 4,
            label: 'Z toho počet detí do 17 rokov',
            categoryId: 0,
            labelInfo: '(ak je uplatňovaný daňový bonus)',
            value: 0,
            items: [],
            valueInfo: 'Počet detí, ktoré dovŕšili menej ako 14 rokov, žijúce v jednej domácnosti, na ktoré si žiadateľ uplatňuje daňový bonus.',
            type: 'text',
            isAmount: false,
          },
          {
            id: 5,
            label: 'Z toho počet detí 18 do 26 rokov',
            categoryId: 0,
            labelInfo: '(ak je uplatňovaný daňový bonus)',
            value: 0,
            items: [],
            valueInfo: 'Počet detí, ktoré dovŕšili viac ako 15 rokov a nedovŕšili ešte 18 rokov (max. 17 rokov a 365 dní), žijúce v jednej domácnosti, na ktoré si žiadateľ uplatňuje daňový bonus.',
            type: 'text',
            isAmount: false,
          },
        ],
        [
          {
            id: 6,
            label: 'IČO zamestnávateľa',
            categoryId: 0,
            labelInfo: '',
            value: null,
            items: [],
            valueInfo: '',
            type: 'text',
            isAmount: false,
          },
          {
            id: 7,
            label: 'Zamestnaný od',
            categoryId: 0,
            labelInfo: '',
            value: null,
            items: [],
            valueInfo: 'Dátum, odkedy pracujete pre aktuálneho zamestnávateľa.',
            type: 'date',
          },
        ],
        [
          {
            id: 8,
            label: 'Čistý mesačný príjem zo zamestnania',
            categoryId: 0,
            labelInfo: '',
            value: 0,
            items: [],
            valueInfo: 'Priemerný hrubý mesačný príjem za posledných 12 mesiacov.',
            type: 'text',
            isAmount: true,
          },
          {
            id: 9,
            label: 'Súhrnná výška dochodkov v čistom',
            categoryId: 0,
            labelInfo: '',
            value: 0,
            items: [],
            valueInfo: 'Súčet dôchodkov, ktoré sú vám mesačne vyplácané: starobný dôchodok, invalidný dôchodok a iné. Sumu uvádzate v čistom.',
            type: 'text',
            isAmount: true,
          },
        ],
        [
          {
            id: 10,
            label: 'Súdom stanovené zrážky/platby',
            categoryId: 0,
            labelInfo: '',
            value: 0,
            items: [],
            valueInfo: '',
            type: 'text',
            isAmount: true,
          },
          {
            id: 11,
            label: 'Celková suma aktuálných záväzkov',
            categoryId: 0,
            labelInfo: '',
            value: 0,
            items: [],
            valueInfo: 'Súčet zostatkov úverov a pôžičiek, ktoré aktuálne splácate.',
            type: 'text',
            isAmount: true,
          },
        ],
        [
          {
            id: 12,
            label: 'Celková suma aktuálných mesačných splátok',
            categoryId: 0,
            labelInfo: '',
            value: 0,
            items: [],
            valueInfo: 'Súčet mesačných splátok úverov a pôžičiek, ktoré aktuálne splácate.',
            type: 'text',
            isAmount: true,
          },
        ],
      ],
  
    }),
    watch: {
      showDalsiPrijem(value) {
        if (!value) {
          this.dalsiPrijem.inyCistyPrijem.value = 0;
          this.dalsiPrijem.inyTypPrijmu.value = 0;
        }
      },
      value(val){
      }
    },
    computed: {
      ...mapState(['pripad']),
      // ...mapGetters(['odoslatNaSchvalenieRequest']),
      
    },
    mounted() {
      this.loadScoring();
    },
    methods: {
      ...mapMutations(['openDialog','setLoadingDialog']),
      // Tu v pripad.cislo_plz by mohlo byt inicializované
      //...mapGetters(['pripad']),
      ...mapGetters(['jeDealer']),
      async saveData() {
        let error = false;
        if (this.$refs['form'].validate()) {
          if (this.formaPodnikania.pkId == 3) {
            this.setLoadingDialog({open:open,btext:'Prebieha proces ukladania dodatočných informácií...',utext:'Proces môže trvať aj niekoľko sekúnd'});
            await this.saveScoring()
          }
        }else{
          error = true;      
        }
        return error;
      },
      onRodneCisloInput(v, user) {
        if (!user.zahranicna_osoba) {
          const rdcObj = this.parseRdc(v);
          if(v?.length > 5)
            user.datumNarodenia = rdcObj.datum;
        }
      },
      parseRdc(rdc) {
        const obj = { datum: null, pohlavie: null };
        const koncovka = rdc.substring(6, 12);
        const y = rdc.substring(0, 2);
        const m = rdc.substring(2, 4);
        const d = rdc.substring(4, 6);
  
        let datum = '';
  
        if (koncovka.length === 3) datum += '19';
        else if (koncovka.length === 4 && Number(y) >= 54) datum += '19';
        else datum += '20';
        datum += y;
        datum += '-';
        if (m.charAt(0) === '5') datum += '0' + m.charAt(1);
        else if (m.charAt(0) === '6') datum += '1' + m.charAt(1);
        else datum += m;
        datum += '-';
        datum += d;
  
        obj.pohlavie = Number(m) > 50 ? 2 : 1;
        obj.datum = datum;
  
        return obj;
      },
      getRulesRodCislo(user){
        let rodCisloRules = [this.rules.required];
        if(!user.zahranicnaOsoba)
          rodCisloRules.push(this.rules.rodCislo)
        return rodCisloRules;
      },
      // Dokončiť
      saveScoring() {
        //var cislo_plz = '164000009000';
        if(this.$refs['form'].validate()){
          return { error: '', data: this.createScoringParams() }
        }else{
          return { error: "Prosím vyplňte všetky povinné polia!", data: null }
        }
      },
      createScoringParams() {
        var params = [];
        this.rows.forEach(rowArray => {
          rowArray.forEach(row => {
            let rowValue = row.value == undefined ? '0': row.value.toString();
            if(row.type == "text" && row.isAmount == true){
              let splitValue = rowValue.split('.');
              rowValue = splitValue[0];
            }
            params.push({
              id: row.categoryId,
              value: rowValue,
              spoludlznik: this.spoludlznik == true ? 1 : 0
            })
          })
        })

        for(let key in this.dalsiPrijem){
            let rowValue = this.dalsiPrijem[key].value == undefined ? '0' : this.dalsiPrijem[key].value.toString();
            if(this.dalsiPrijem[key].type == "text" && key == "inyCistyPrijem"){
                let splitValue = rowValue.split('.');
                rowValue = splitValue[0];
            }
            params.push({
              id: this.dalsiPrijem[key].categoryId,
              value: rowValue,
              spoludlznik: this.spoludlznik == true ? 1 : 0
            })
        }
        return params;
      },
      getZamestnanyOdReuired(){
        const target = this.rows.flat().find(obj => obj.id === 6);
        if(target.value == null || target.value == 0 || target.value == ""){
          return true;
        }else{
          return this.rules.required;
        }
      },
      loadScoring() {
        const categoryMap = new Map();
        this.value.forEach(item => {
          const rowId = this.categories[item.id_category];
          if (rowId !== undefined) {
            if (!categoryMap.has(rowId)) {
              categoryMap.set(rowId, []);
            }
            categoryMap.get(rowId).push(item);
          }
        });

        this.rows.forEach(rowArray => {
          rowArray.forEach(row => {
            const dataItems = categoryMap.get(row.id);

            if (dataItems) {
              dataItems.forEach(dataItem => {
                row.label = dataItem.category;
                row.labelInfo = dataItem.category2;
                row.categoryId = dataItem.id_category;
                row.value = dataItem.control_value;
                if (row.type === 'auto') {
                  row.items.push({
                    value_member: dataItem.value_member,
                    display_member: dataItem.display_member
                  });
                }
              });
            }
          });
        });

        for(let key in this.dalsiPrijem){
          const dataItems = categoryMap.get(this.dalsiPrijem[key].id);
          if (dataItems) {
            dataItems.forEach(dataItem => {
              this.dalsiPrijem[key].label = dataItem.category;
              this.dalsiPrijem[key].labelInfo = dataItem.category2;
              this.dalsiPrijem[key].categoryId = dataItem.id_category;
              this.dalsiPrijem[key].value = dataItem.control_value;
              if (this.dalsiPrijem[key].type === 'auto') {
                this.dalsiPrijem[key].items.push({
                  value_member: dataItem.value_member,
                  display_member: dataItem.display_member
                });
              }
            });
          }
        }

        this.showDalsiPrijem = this.dalsiPrijem.inyCistyPrijem.value != 0;
        
        this.isScoringLoaded = true;
      },
    },
    created() {
    },
  };
  </script>
  